import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "edit-business-tab__container" }

import { i18n } from '@/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditIndividualBusinessPageTab',
  props: {
    isBaseBusiness: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any) {

const props = __props;

const t = i18n.t;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(props.isBaseBusiness ? 'edit-business-tab__button--inactive' : 'edit-business-tab__button--active'),
      onClick: _cache[0] || (_cache[0] = () => _ctx.$emit('click', false))
    }, _toDisplayString(_unref(t)('仕入取引')), 3),
    _createElementVNode("button", {
      class: _normalizeClass(props.isBaseBusiness ? 'edit-business-tab__button--active' : 'edit-business-tab__button--inactive'),
      onClick: _cache[1] || (_cache[1] = () => _ctx.$emit('click', true))
    }, _toDisplayString(_unref(t)('販売取引')), 3)
  ]))
}
}

})